module.exports = __webpack_public_path__ + "img/3.93b45801.jpg";